<!--suppress HtmlUnknownTag -->
<template>
    <label
        :class="[
            'radio-image-field',
            { 'radio-image-field_checked': isChecked }
        ]"
    >
        <input
            :id="id"
            type="radio"
            :value="value"
            class="radio-image-field__input"
            :checked="isChecked"
            @change="onChange"
        />

        <div class="radio-image-field__image-wrapper">
            <img
                :src="imageSrc"
                class="radio-image-field__image"
            />
        </div>

        <div class="radio-image-field__content">
            <span class="radio-image-field__circle"></span>

            <span
                v-if="label"
                class="radio-image-field__title"
            >
                {{ label }}
            </span>
        </div>
    </label>
</template>

<script lang="ts" setup>
    import { inject, computed } from 'vue';

    const props = defineProps({
        value: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        imageSrc: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
    });

    const radioGroup = inject<{
        modelValue: { value: string },
        updateModelValue: (value: string) => void,
    }>('radioGroup');

    if (!radioGroup) {
        console.error('UIRadioImage должен использоваться внутри UIRadioGroup');
    }

    const isChecked = computed(() => radioGroup?.modelValue.value === props.value);

    const onChange = (): void => {
        radioGroup?.updateModelValue(props.value);
    };
</script>

<style lang="scss" scoped>
    @use './UIRadioImage.scss' as *;
</style>
